// Local Functions
const buildExploreLink = ({ langCode, link, urlPrefix }) =>
  `/${langCode}/magazine/${link.label === 'See All' ? 'category' : urlPrefix}${link.url}/`;

// Module Exports
export { buildExploreLink };
